import { filter as f, identity as id, join, uniq, __} from "ramda";
import "./project.css";

export const Years = ({start,end}) => {
    const existing = uniq(f(id,[start,end]));
    const current_year = new Date().getFullYear();
    return <p className="years">{end === null ? start + " - ..." : join(" - ",existing)}</p>;
}
